<template>
  <div>
    <v-app-bar dense app color="dark" dark fixed class="simulator-app-bar">
      <v-menu
        bottom
        left
        :close-on-content-click="false"
        :nudge-width="400"
        offset-y
        dense
        rounded
        class="elevation-6"
        min-width="300"
        max-width="300"
      >
        <template v-slot:activator="{ on: menu, attrs }">
          <v-tooltip dense bottom>
            <template v-slot:activator="{ on: tooltip }">
              <v-btn dense v-bind="attrs" icon :small="compact" aria-label="Menu" v-on="{ ...tooltip, ...menu }">
                <v-icon>mdi-menu</v-icon>
              </v-btn>
            </template>
            <span>Menu</span>
          </v-tooltip>
        </template>
        <v-list>
          <v-list-item to="/dashboard">
            <v-list-item-action>
              <v-icon>mdi-home</v-icon>
            </v-list-item-action>
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item>
          <v-list-item link @click="openPlotOptions(true)">
            <v-list-item-action>
              <v-icon>mdi-play</v-icon>
            </v-list-item-action>
            <v-list-item-title>Run simulation</v-list-item-title>
          </v-list-item>
          <!-- No celular, os botões da direita da barra ficam aqui -->
          <template v-if="compact">
            <v-list-item link @click="view_confirm_eraser_modal = true">
              <v-list-item-action>
                <v-icon>mdi-eraser</v-icon>
              </v-list-item-action>
              <v-list-item-title>Clear canvas</v-list-item-title>
            </v-list-item>
            <v-list-item link @click="guide = true">
              <v-list-item-action>
                <v-icon>mdi-book-open-variant</v-icon>
              </v-list-item-action>
              <v-list-item-title>Quick guide</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item to="/examples">
            <v-list-item-action>
              <v-icon>mdi-flask-outline</v-icon>
            </v-list-item-action>
            <v-list-item-title>Ready-to-run examples</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            :small="compact"
            v-bind="attrs"
            v-on="on"
            :color="mode == 'transform' ? 'primary' : ''"
            @click="setCurrentMode('transform')"
          >
            <v-icon style="transform: rotate(-20deg)"> mdi-navigation </v-icon>
          </v-btn>
        </template>
        <span>Move or Select </span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            :small="compact"
            v-on="on"
            v-bind="attrs"
            :color="mode == 'sources' ? 'primary' : ''"
            @click="setCurrentMode('sources')"
          >
            <v-icon>mdi-plus-circle-multiple-outline</v-icon>
          </v-btn>
        </template>
        <span>Create Source</span>
      </v-tooltip>
      <v-tooltip v-if="!is3d" bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            :small="compact"
            v-on="on"
            v-bind="attrs"
            :color="mode == 'flux' ? 'primary' : ''"
            @click="setCurrentMode('flux')"
          >
            <v-icon>mdi-access-point</v-icon>
          </v-btn>
        </template>
        <span>Add output (spectrum or resonance)</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            :small="compact"
            v-on="on"
            v-bind="attrs"
            :color="mode == 'handOn' ? 'primary' : ''"
            @click="setCurrentMode('handOn')"
          >
            <v-icon>mdi-hand</v-icon>
          </v-btn>
        </template>
        <span>Pan the canvas</span>
      </v-tooltip>
      <v-menu
        bottom
        :close-on-content-click="false"
        :nudge-width="400"
        offset-y
        open-on-hover
        rounded="lg"
        class="elevation-6"
        min-width="100"
        max-width="300"
      >
        <template v-slot:activator="{ on: menu, attrs }">
          <v-tooltip dense bottom>
            <template v-slot:activator="{ on: tooltip }">
              <v-btn
                :color="mode == 'zoom' ? 'primary' : ''"
                v-bind="attrs"
                icon
                :small="compact"
                v-on="{ ...tooltip, ...menu }"
              >
                <v-icon>
                  {{
                    zoomAction == "In"
                      ? "mdi-magnify-plus-outline"
                      : zoomAction == "Out"
                      ? "mdi-magnify-minus-outline"
                      : "mdi-magnify-plus-outline"
                  }}
                </v-icon>
              </v-btn>
            </template>
            <span>Zoom</span>
          </v-tooltip>
        </template>
        <v-list dense>
          <v-list-item dense color="primary" @click="setZoomActionState('In')">
            <v-list-item-action>
              <v-icon>mdi-magnify-plus-outline</v-icon>
            </v-list-item-action>
            <v-list-item-title>Zoom In</v-list-item-title>
          </v-list-item>
          <v-list-item dense @click="setZoomActionState('Out')">
            <v-list-item-action>
              <v-icon>mdi-magnify-minus-outline</v-icon>
            </v-list-item-action>
            <v-list-item-title>Zoom Out</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-menu
        bottom
        :close-on-content-click="false"
        :nudge-width="400"
        offset-y
        open-on-hover
        rounded="lg"
        class="elevation-6"
        min-width="100"
        max-width="300"
      >
        <template v-slot:activator="{ on: menu, attrs }">
          <v-tooltip dense bottom>
            <template v-slot:activator="{ on: tooltip }">
              <v-btn
                :color="mode == 'create' ? 'primary' : ''"
                v-bind="attrs"
                icon
                :small="compact"
                v-on="{ ...tooltip, ...menu }"
              >
                <v-icon>{{ currentShapeIcon }}</v-icon>
              </v-btn>
            </template>
            <span>Geometry</span>
          </v-tooltip>
        </template>
        <v-list dense>
          <v-list-item
            v-for="option in shapeOptions"
            :key="option.shape"
            dense
            :input-value="shape === option.shape"
            color="primary"
            @click="setShapeOfCurrentGeometryState(option.shape)"
          >
            <v-list-item-action>
              <v-icon>{{ option.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-title>{{ option.label }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn
        v-if="!$vuetify.breakpoint.smAndDown"
        :text="!sincronizado"
        :disabled="sincronizado"
        dense
        @click="updateState"
        >{{ sincronizado ? "Data Saved" : "Save changes" }}</v-btn
      >
      <v-btn
        v-else
        icon
        :small="compact"
        :disabled="sincronizado"
        :aria-label="sincronizado ? 'Data saved' : 'Save changes'"
        @click="updateState"
      >
        <v-icon>{{ sincronizado ? "mdi-cloud-check-outline" : "mdi-content-save-outline" }}</v-icon>
      </v-btn>
      <!-- Desfazer / refazer (Ctrl+Z, Ctrl+Shift+Z ou Ctrl+Y) -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon :small="compact" v-bind="attrs" :disabled="!canUndo" aria-label="Undo" v-on="on" @click="undo">
            <v-icon>mdi-undo</v-icon>
          </v-btn>
        </template>
        <span>Undo (Ctrl+Z)</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon :small="compact" v-bind="attrs" :disabled="!canRedo" aria-label="Redo" v-on="on" @click="redo">
            <v-icon>mdi-redo</v-icon>
          </v-btn>
        </template>
        <span>Redo (Ctrl+Shift+Z)</span>
      </v-tooltip>
      <v-spacer />

      <v-tooltip v-if="!compact" dense bottom>
        <template v-slot:activator="{ on: tooltip, attrs }">
          <v-btn
            @click="view_confirm_eraser_modal = true"
            v-bind="attrs"
            icon
            v-on="tooltip"
          >
            <v-icon>mdi-eraser</v-icon>
          </v-btn>
        </template>
        <span>Clear Canvas</span>
      </v-tooltip>
      <v-dialog max-width="340" v-model="view_confirm_eraser_modal">
        <v-card>
          <v-card-title class="text-h6">Clear the canvas?</v-card-title>
          <v-card-text>
            All geometries, sources and outputs of this simulation will be removed. You can undo it with Ctrl+Z or the ↶ button.
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn text @click="view_confirm_eraser_modal = false">Cancel</v-btn>
            <v-btn color="error" text @click="confirmClearCanvas">Clear</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <QuickGuideDialog v-model="guide" />
      <v-snackbar
        v-model="showNotice"
        :timeout="notice.undo ? 6000 : 1800"
        :style="compact ? 'margin-bottom: 60px' : ''"
      >
        {{ notice.text }}
        <template v-slot:action="{ attrs }">
          <v-btn v-if="notice.undo" text color="primary" v-bind="attrs" @click="undoFromNotice">Undo</v-btn>
          <v-btn icon small v-bind="attrs" aria-label="Close" @click="showNotice = false">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </template>
      </v-snackbar>
      <template v-if="!compact">
        <HelpButton />
        <Notifications />
        <MenuButton />
      </template>
    </v-app-bar>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "NavbarDrawing",
  components: {
    MenuButton: () => import("@/components/MenuButton"),
    Notifications: () => import("@/components/Notifications"),
    HelpButton: () => import("@/components/HelpButton"),
    QuickGuideDialog: () => import("@/components/QuickGuideDialog")
  },
  props: {
    is3d: { type: Boolean, default: false }
  },
  computed: {
    ...mapGetters("simulator", ["shape", "mode", "zoomAction", "sincronizado", "canUndo", "canRedo", "notice", "selectedToken"]),
    // Em telas estreitas a barra só mostra as ferramentas de desenho; o resto vai para o menu
    compact() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    // O 2D (Meep) aceita bloco, triângulo e círculo; o 3D (Gmsh) também os sólidos abaixo
    shapeOptions() {
      const common = [
        { shape: "block", label: this.is3d ? "Box" : "Block", icon: this.is3d ? "mdi-cube-outline" : "mdi-square" },
        { shape: "triangle", label: this.is3d ? "Triangular prism" : "Triangle", icon: "mdi-triangle" },
        { shape: "sphere", label: this.is3d ? "Sphere" : "Circle", icon: "mdi-circle" }
      ];
      if (!this.is3d) return common;
      return [
        ...common,
        { shape: "cylinder", label: "Cylinder", icon: "mdi-database" },
        { shape: "cone", label: "Cone", icon: "mdi-traffic-cone" },
        { shape: "pyramid", label: "Pyramid", icon: "mdi-triangle-outline" },
        { shape: "ring", label: "Ring", icon: "mdi-circle-double" },
        { shape: "lozangle", label: "Rhombic prism", icon: "mdi-rhombus" },
        { shape: "trapeze", label: "Trapezoidal prism", icon: "mdi-vector-polygon" }
      ];
    },
    currentShapeIcon() {
      const option = this.shapeOptions.find(item => item.shape === this.shape);
      return option ? option.icon : this.shapeOptions[0].icon;
    },
    nocturne: {
      get() {
        return this.$vuetify.theme.dark;
      },
      set(val) {
        localStorage.setItem("NOCTURNE_MODE_ELECTROSFI", val);
        this.$vuetify.theme.dark = val;
      }
    }
  },
  data() {
    return {
      user: "",
      view_confirm_eraser_modal: false,
      guide: false,
      showNotice: false,
      view_dropdown_menu: false,
      view_dropdown_menu_geometries: false,
      view_dropdown_menu_zoom: false,
      drawing: false,
    };
  },
  watch: {
    "notice.id"() {
      this.showNotice = !!this.notice.text;
    }
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.onShortcut);
  },
  mounted() {
    document.addEventListener("keydown", this.onShortcut);
    this.getUser();
    // A forma escolhida fica no store: um sólido escolhido no 3D não existe no 2D
    if (!this.shapeOptions.some(option => option.shape === this.shape)) {
      this.setShapeOfCurrentGeometry("block");
    }
  },
  methods: {
    ...mapActions("simulator", [
      "setShapeOfCurrentGeometry",
      "setCurrentMode",
      "setZoomAction",
      "openPlotOptions",
      "clearCanvas",
      "updateState",
      "undo",
      "redo",
      "GeometryListRemove"
    ]),
    // Atalhos de edição; ignorados enquanto o usuário digita num campo (lá Ctrl+Z desfaz o texto)
    onShortcut(event) {
      const target = event.target || {};
      if (["INPUT", "TEXTAREA", "SELECT"].includes(target.tagName) || target.isContentEditable) return;
      const key = (event.key || "").toLowerCase();
      const modifier = event.ctrlKey || event.metaKey;
      if (modifier && key === "z") {
        event.preventDefault();
        if (event.shiftKey) this.redo();
        else this.undo();
      } else if (modifier && key === "y") {
        event.preventDefault();
        this.redo();
      } else if (!modifier && (key === "delete" || key === "backspace") && this.selectedToken) {
        event.preventDefault();
        this.GeometryListRemove(this.selectedToken);
      }
    },
    undoFromNotice() {
      this.showNotice = false;
      this.undo();
    },
    confirmClearCanvas() {
      this.view_confirm_eraser_modal = false;
      this.clearCanvas();
    },
    getUser: function() {
      this.user = window.firebase.auth().currentUser;
    },
    awayMenuClick: function() {
      if (this.view_dropdown_menu) {
        this.view_dropdown_menu = false;
      }
      if (this.view_dropdown_menu_geometries) {
        this.view_dropdown_menu_geometries = false;
      }
      if (this.view_dropdown_menu_zoom) {
        this.view_dropdown_menu_zoom = false;
      } // this.menuAtivo = "Nenhum";
    },
    setShapeOfCurrentGeometryState: function(string) {
      this.setShapeOfCurrentGeometry(string);
      this.setCurrentMode("create");
      this.awayMenuClick();
    },
    setZoomActionState: function(string) {
      this.setCurrentMode("zoom");
      this.setZoomAction(string);
      this.awayMenuClick();
    },
    AlteraForma: function(data) {
      this.$emit("AlteraForma", data);
    },
    updateColor: function(data) {
      this.$emit("updateColor", data);
    },
    squareClick: function() {
      this.DefineMode("create");
      this.AlteraForma("rect");
      // this.updateColor("#000");
    },
    openModal: function(data) {
      this.menuAtivo = "Nenhum";
      this.$emit("openModal", data);
    }
  }
};
</script>
<style lang="scss">
@import "./styles.scss";
</style>
